import React, { Component } from 'react';
import SingleBotcard from '../BotCatalog/SingleBotcard';

require('./dashboard.css');

var firebase = require('firebase');
var db = firebase.firestore();


var editEnabled = false;

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            signStatus: '',
            photoURL: '',
            summaryLine: '',
            useremail: '',
            name: '',
            visitor: false,
            errorOccured: '',
            allApps: [],
            dataRecieved: false
        };

        this.editProfileCard = this.editProfileCard.bind(this);
    }

    componentWillMount() {
        var pageUserName = this.props.match.params.username, referThis = this;
        var userAppsPath = db.collection('applications').where("username", "==", pageUserName).limit(1), counter = 0;
        var userFinder = db.collection('users').where("username", "==", pageUserName), userExist = false;

        //Check if the page user exists or not first
        userFinder.get().then(function (userInfo) {
            userInfo.forEach(function (checker) {
                if (checker && checker.exists) {
                    userExist = true;
                }
            });
        }).catch(err => {
            //The user does not exist
            userExist = false;
        }).then(() => {
            if (userExist) {

                //Get the user's info
                userFinder.get().then(function (userInfo) {
                    //There should only be one so the foreach statement wouldn't hurt (as far as I know);
                    userInfo.forEach(function (eachUser) {
                        
                        referThis.setState({
                            username: eachUser.data().username,
                            signStatus: true,
                            photoURL: eachUser.data().photoUrl,
                            useremail: eachUser.data().email,
                            name: eachUser.data().name,
                            summaryLine: eachUser.data().summaryLine,
                            visitor: false
                        });
                    });
                }).catch(err => {
                    //There was an error getting this page's user information
                    document.getElementById('messagePlace').innerText = 'There was an error getting data: ' + err.code;
                }).then(() => {
                    //success getting the user's info
                    referThis.setState({
                        dataRecieved: true
                    });
                });
                //Check if the uid user already exists
                firebase.auth().onAuthStateChanged(function (user) {
                    //user is already logged in 
                    if (user) {
                        /***Check if the current user is the same as the visitor or not.  */
                        var docRef = db.collection("users").doc(user.email.toString());
                        docRef.get().then(doc => {
                            if (doc && doc.exists) {
                                //compare the usernames. 
                                if (doc.data().username === pageUserName) {
                                    //The user is the same. 
                                    referThis.setState({
                                        visitor: false
                                    });
                                } else {
                                    //The user is a visitor so no need to get anything unless actions taken by current user. 
                                    referThis.setState({
                                        visitor: true
                                    });
                                }
                            } else {
                                console.log("Current Signed-in User does not exist");
                                //This user does not exist therefore return an error...
                                window.location.replace(`/error/userdoesnotexist`);
                            }
                        }).catch(function (err) {
                            //There was an error getting user's information 
                            return (
                                <h1>There was an error getting your information, please try again later!</h1>
                            );
                        });
                    } else {
                        referThis.setState({
                            signStatus: false
                        })
                    }
                }, function (error) {
                    referThis.setState({
                        signStatus: false
                    });
                    document.getElementById('messagePlace').innerText = 'There was an error getting data: ' + error.code;
                }, function () {
                    //on success
                    referThis.setState({
                        dataRecieved: true
                    });
                });

                //Get all the applications for the particular user
                userAppsPath.get().then(function (allApps) {
                    var allAppsArray = [];

                    //Loop through each app under the user name.
                    allApps.forEach(function (eachApp) {
                        var eachAppDetails = {};
                        counter += 1;

                        console.log("App Counter: " + counter);
                        console.log("App Info: " + eachApp.data().appName);
                        //Set each app details into this object
                        eachAppDetails.appName = eachApp.data().appName;
                        eachAppDetails.appType = eachApp.data().appType;
                        eachAppDetails.appDbLink = eachApp.data().dbPath;
                        eachAppDetails.appStorageLink = eachApp.data().filesPath;
                        eachAppDetails.appUserEmail = eachApp.data().userEmail;
                        eachAppDetails.counter = counter;


                        allAppsArray.push(eachAppDetails);
                    });

                    referThis.setState({
                        allApps: allAppsArray
                    });
                }).catch(err => {
                    //There was an error getting the documents. 
                    document.getElementById('messagePlace').innerText = 'There was an error getting data: ' + err.code;
                }).then(() => {
                    //All the data has been received. 
                    referThis.setState({
                        dataRecieved: true
                    });
                });
            } else {
                window.location.replace(`/error/userdoesnotexist`);
            }

        });


    }

    //Allows the user to edit their name and summary line. 
    editProfileCard() {
        var nameLine = document.getElementById('nameLine');
        var summaryLine = document.getElementById('summaryLine');

        if (!this.state.visitor) {
            if (!editEnabled) {
                editEnabled = true;
                //make the lines editable
                nameLine.contentEditable = "true";
                summaryLine.contentEditable = "true";

                //underline the items
                nameLine.style.borderBottom = '1px solid blue';
                summaryLine.style.borderBottom = '1px solid blue';

            } else {
                //make the lines un-editable
                nameLine.contentEditable = "false";
                summaryLine.contentEditable = "false";

                //Remove the underlines
                nameLine.style.borderBottom = 'none';
                summaryLine.style.borderBottom = 'none';
                editEnabled = false;

                //Submit the text that is in the places. 

                if (this.state.signStatus) {
                    //if the user is signed in

                    var docRef = db.collection("users").doc(this.state.useremail.toString());
                    docRef.get().then(doc => {
                        if (doc && doc.exists) {
                            //The user exists confirmation
                            let newNameLine = nameLine.innerText, newSummaryLine = summaryLine.innerText;
                            docRef.set({
                                name: newNameLine,
                                summaryLine: newSummaryLine
                            }, { merge: true })
                                .catch(error => {
                                    window.alert("There was an alert submitting this information!");
                                    window.alert("Error: " + error);
                                })
                                .then(function (success) {
                                    console.log("Success sending the data!!");
                                });

                        } else {
                            document.getElementById('errorMessageSpace').innerText += "Problem getting user data! Please try again later..";
                        }
                    }).catch(error => {
                        console.log("Error getting user data: " + error.message);
                    });
                } else {
                    document.getElementById('errorMessageSpace').innerText += "Please Sign In!";
                }
            }
        }
    }

    addBot = () => {
        window.location.replace('/AddBot');
    }

    render() {
        while (!this.state.dataRecieved) {
            console.log("Data Recieved: " + this.state.dataRecieved);
            return (
                <div className="loadingDiv text-center">
                    <br />
                    <h3><i className="fab fa-pied-piper-alt" id='spinner' ></i></h3>
                    <br />
                </div>
            );
        }

        var allAppsArray = this.state.allApps;
        return (
            <div>
                <div className="container">
                    <br />
                    <div className="card profileCard" id="profileCardDiv">
                        <img className="card-img-top profileImage" src={this.state.photoURL} alt={this.state.username}
                        />
                        <div className="card-block text-center">
                            <br />
                            <small id="errorMessageSpace"></small>
                            <h3 id="nameLine">{this.state.name}</h3>
                            <h5 id="summaryLine">{this.state.summaryLine}</h5>
                            <br />
                            <div className="editButtonDiv"
                                style={{ display: this.state.visitor ? 'none' : 'block' }}
                            >
                                <button className="btn" id="editButton" onClick={() => this.editProfileCard()}>
                                    <i className="far fa-edit"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <button type="button" className="btn" id='AddOwnBotButton' onClick={() => this.addBot()}>
                        <i className="fas fa-plus-circle"></i>&nbsp;
                          Add An App
                    </button>
                    <br />
                    <br />
                    <br />
                    <h3>Apps: </h3>
                    <small id="messagePlace"></small>
                    <div className="row bot_card_rows">
                        {
                            allAppsArray.map((data, i) => <SingleBotcard {...data} key={data.counter + i + data.counter} />)
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/Authentication/Dashboard.js